// extracted by mini-css-extract-plugin
module.exports = {"visitsTitle":"allvisits_visitsTitle__1mfdd","visitsTable":"allvisits_visitsTable__15NyM","row":"allvisits_row__3NdXQ"};